import { IconChevron } from '@components/icons/icon-chevron';
import { DisclosureButton } from '@headlessui/react';
import { mergeTwClasses } from '@utils/merge-tw-classes/merge-tw-classes';

import { AccordionHeaderProps } from './accordion.type';

export const AccordionHeader = ({ children, className, showChevron = true, ...props }: AccordionHeaderProps) => (
  <DisclosureButton
    className={mergeTwClasses(
      'w-full flex items-center justify-between px-4 py-3 text-neutral-70 dark:text-neutral-8',
      className
    )}
    {...props}>
    {({ open }) => (
      <>
        <div className='flex flex-1 text-inherit mr-4'>{children}</div>
        {showChevron && (
          <IconChevron
            aria-hidden='true'
            className={mergeTwClasses(
              'h-5 w-5 -mr-1 text-neutral-30 transition-transform dark:text-neutral-60',
              open ? 'rotate-90' : '-rotate-90'
            )}
          />
        )}
      </>
    )}
  </DisclosureButton>
);
